import { defineStore } from "pinia";

export const useRootStore = defineStore("root", () => {
  const _brand = ref("bebitalia");
  const _salesline = ref("");
  const _langs = ref(["it", "en", "en-us", "fr", "de", "es", "ko", "ja"]);
  const _cdnFolder = ref("ce_beb_prod");
  const _host = ref("");
  const _avif = ref("");

  const langs = computed(() => _langs.value);
  const brand = computed(() => _brand.value);
  const salesline = computed(() => _salesline.value);
  const avif = computed(() => _avif.value);
  const host = computed(() => _host.value);
  const cdnFolder = computed(() => _cdnFolder.value);

  function setCDNFolder(value) {
    // if (!value) {
    //   return;
    // }

    // if (
    //   /^ce_beb_stag$|^ce_beb_prod$|^collection-exp$|^ce_maxalto_stag$|^ce_maxalto_prod$/.test(
    //     value
    //   )
    // ) {
    //   _cdnFolder.value = folder;
    //   return;
    // }

    // const config = useRuntimeConfig();

    // if (
    //   config.public.environment == "stag-bebitalia" ||
    //   value?.match("staging-collection-experience.bebitalia.com")
    // ) {
    //   // B&B Italia - staging
    //   //_cdnFolder.value = "ce_beb_stag";
    //   _cdnFolder.value = "collection-exp";
    // } else if (
    //   config.public.environment == "bebitalia" ||
    //   value?.match("collection-experience.bebitalia.com")
    // ) {
    //   // B&B Italia - prod
    //   //_cdnFolder.value = "ce_beb_prod";
    //   _cdnFolder.value = "collection-exp";
    // } else if (
    //   config.public.environment == "stag-maxalto" ||
    //   value?.match("staging-collection-experience.maxalto.com")
    // ) {
    //   // Maxalto - staging
    //   //_cdnFolder.value = "ce_maxalto_stag";
    //   _cdnFolder.value = "collection-exp";
    // } else if (
    //   config.public.environment == "maxalto" ||
    //   value?.match("collection-experience.maxalto.com")
    // ) {
    //   // Maxalto - prod
    //   //_cdnFolder.value = "ce_maxalto_prod";
    //   _cdnFolder.value = "collection-exp";
    // } else if (value?.match("localhost")) {
    //   // B&B Italia - prod
    //   //_cdnFolder.value = "ce_beb_prod";
    //   _cdnFolder.value = "collection-exp";
    // }

    _cdnFolder.value = "collection-exp";
  }

  function setBrand(value) {
    _brand.value = /^maxalto$|^bebitalia$/.test(value) ? value : "bebitalia";
    return _brand.value;
  }

  function setSalesline(value) {
    if (!value) {
      return;
    }
    _salesline.value = value;
    return _salesline.value;
  }

  function setAvif(value) {
    _avif.value = value;
    return _avif.value;
  }

  function setHost(value) {
    _host.value = value;
    return _host.value;
  }

  return {
    setBrand,
    setAvif,
    setSalesline,
    setCDNFolder,
    setHost,
    brand,
    avif,
    langs,
    cdnFolder,
    host,
    salesline,
  };
});
